export const questions = {
  QUESTION_1: "Customized question for your recruiting process.",
  QUESTION_2: "What is your age?",
  QUESTION_3: "What is your favorite color?",
};
